<template>
  <Layout>
    <div class="section content is-size-6 has-text-white">
      <h1 class="is-size-5 has-text-primary">{{$t('Error')}}</h1>
      <span class="is-size-6">
        <p>
          {{ $t('Unexpected error occurred') }}
        </p>
        <p><router-link :to="{ name: 'LP' }" class="button is-success">{{ $t('Try again') }}</router-link></p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'PaymentError',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/PaymentError.vue